import { StateCreator } from 'zustand'

import { ConfigSliceActions } from './configSlice.actions'
import { ConfigSliceParts } from './configSlice.parts'
import type { ENVIRONMENTS } from './configSlice.parts'

export type ConfigState = {
  VERSION: string | null
  AUTH0_DOMAIN: string
  AUTH0_CLIENTID: string
  AUTH_AUDIENCE: string
  API_URL: string
  ENVIRONMENT: ENVIRONMENTS
  AGGRID_LICENSE: string
  APPINSIGHTS_CONNECTION_STRING: string | null
  isEnvironment: (environments: ENVIRONMENTS | ENVIRONMENTS[]) => boolean
}

export type ConfigSlice = {
  config: ConfigState
}

export const configSlice: StateCreator<ConfigSlice, [], [], ConfigSlice> = (
  set,
  get,
) => {
  void set
  return {
    config: {
      ...ConfigSliceParts.createInitialConfigState(),
      isEnvironment: (environments: ENVIRONMENTS | ENVIRONMENTS[]) => {
        return ConfigSliceActions.isEnvironment(environments)(get())
      },
    },
  }
}
